module.exports = __webpack_public_path__ + "img/Dantam Bridal 17.85967fde.jpg";